import { render, staticRenderFns } from "./OrderComments.vue?vue&type=template&id=3805b430&"
import script from "./OrderComments.vue?vue&type=script&lang=js&"
export * from "./OrderComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports